//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AsyncObjectSnippetTooltip from '@/components/AsyncObjectSnippetTooltip.vue'
import { alphabet } from '@/constants/translate.js'
import { ChartDesignExtra } from '@/utils/dto/objects.js'
import { adjustColorBrightness } from "@/utils/helpers.js";

export default {
  name: 'TheEcharts',
  props: {
    title: {
      type: String,
      default: 'График'
    },
    columns: {
      type: Array,
      default: () => ['Category', 'Value']
    },
    // Rows as arrays aligned to columns
    rows: {
      type: Array,
      default: () => [
        ['shirt', 5],
        ['cardigan', 20],
        ['chiffon', 36],
        ['pants', 10],
        ['heels', 10],
        ['socks', 20]
      ]
    },
    // 'bar' | 'line'
    type: {
      type: String,
      default: 'line_base'
    },
    height: {
      type: [String, Number],
      default: 400
    },
    axisKey: {
      type: [Number],
      default: null
    },
    axisGroup: {
      type: [Number],
      default: null
    },
    axisValues: {
      type: Array,
      default: () => []
    },
    axisDirection: {
      type: String,
      default: 'column'
    },
    meta: {
      type: Object,
      default: () => ({})
    },
    chartWithValue: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: () => new ChartDesignExtra()
    },
  },
  data() {
    return {
      chart: null,
      legendItems: [],
      legendTooltipMap: {},
      treemapLegendNames: [],
      treemapLegendSelection: {}
    }
  },
  computed: {
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    seriesPalette() {
      if (this.styles?.series_color?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.styles.series_color.palette)[0];
      }

      return null;
    },
    activeColumns() {
      return this.axisValues.length ? this.columns.filter((el, i) => this.axisValues.includes(i)) : this.columns;
    },
    activeKeys() {
      return (this.axisKey || this.axisKey === 0) ? this.rows.map(el => el[this.axisKey]) : this.rows.map(el => el[0]);
    },
    legendOrientation() {
      if (!this.type) return 'horizontal'
      if (this.type.startsWith('circle') || this.type.startsWith('treemap')) return 'vertical'
      return 'horizontal'
    },
    legendClass() {
      return {
        'the-echarts__legend--vertical': this.legendOrientation === 'vertical'
      }
    },
    axisZEnabled() {
      return this.styles.axis_z.enabled === 'none' ? false : true;
    }
  },
  watch: {
    title() {
      this.renderOption()
    },
    columns() {
      this.renderOption()
    },
    rows() {
      this.renderOption()
    },
    axisKey() {
      this.renderOption()
    },
    axisGroup() {
      this.renderOption()
    },
    axisValues: {
      handler() {
        this.renderOption()
      },
      deep: true
    },
    axisDirection() {
      this.renderOption()
    },
    meta: {
      handler() {
        this.renderOption()
      },
      deep: true
    },
    type() {
      this.renderOption()
    },
    height() {
      this.resizeContainer()
      this.chart && this.chart.resize()
    },
    chartWithValue() {
      this.renderOption()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.handleResize, { passive: true })
      }
    })
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
    if (this.chart) {
      if (typeof this.chart.off === 'function') {
        this.chart.off('legendselectchanged', this.handleLegendSelectChanged)
      }
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    resizeContainer() {
      const el = this.$refs.chartEl
      if (!el) return
      const value = typeof this.height === 'number' ? `${this.height}px` : String(this.height)
      el.style.height = value
    },
    async initChart() {
      if (typeof window === 'undefined') return
      if (!this.$refs.chartEl) return

      this.resizeContainer()

      const echarts = this.$echarts
      if (!echarts) return
      this.chart = echarts.init(this.$refs.chartEl)
      if (this.chart && typeof this.chart.on === 'function') {
        this.chart.on('legendselectchanged', this.handleLegendSelectChanged)
      }
      this.renderOption()
    },
    buildOnlyOneSeries(settings = {}) {
      const data = []
      for (let rowIdx = 0; rowIdx < this.activeKeys.length; rowIdx += 1) {
        const rowIndex = this.activeColumns[rowIdx];

        data.push({
          name: this.activeKeys[rowIdx],
          value: Number(this.rows[rowIdx].filter((el, i) => this.axisValues.includes(i))[0]),
        })
      }
      return [
        {
          data,
          ...settings
        }
      ]
    },
    buildSeries(settings = {}) {
      const dataSeries = []
      if (this.axisDirection === 'column') {
        for (let colIdx = 0; colIdx < this.axisValues.length; colIdx += 1) {
          const columnIndex = this.axisValues[colIdx];

          // условие для того, чтобы ключи не работали как значения
          if (!isNaN(Number(this.rows[0][columnIndex]))) {
            const column = Array.isArray(this.columns) ? this.columns[columnIndex] : null
            const columnTitle = column && Object.prototype.hasOwnProperty.call(column, 'title') ? column.title : ''
            const seriesName = this.getHeadLabel(columnTitle, columnIndex)
            dataSeries.push({
              name: seriesName,
              data: this.rows.map(r => this.reduceCommaToDot(r[columnIndex])),
              ...settings
            })
          }
        }
      } else {
        for (let rowIdx = 0; rowIdx < this.activeKeys.length; rowIdx += 1) {
          const rowIndex = this.activeColumns[rowIdx];

          dataSeries.push({
            name: this.activeKeys[rowIdx],
            data: this.rows[rowIdx].filter((el, i) => this.axisValues.includes(i)).map(v => this.reduceCommaToDot(v)),
            ...settings
          })
        }
      }
      return dataSeries
    },
    buildTreemapSeries(settings = {}) {
      this.treemapLegendNames = []
      const treemapData = this.buildTreemapData()
      const labelConfig = this.getTreemapLabelConfig()
      const baseSeriesConfig = {
        type: 'treemap',
        roam: false,
        breadcrumb: { show: false },
        bottom: 60,
        ...labelConfig,
        ...settings
      }

      if (Array.isArray(treemapData) && treemapData.length) {
        this.treemapLegendNames = this.extractTreemapLegendNames(treemapData)
        const selection = this.syncTreemapLegendSelection(this.treemapLegendNames)
        const filteredData = this.filterTreemapDataBySelection(treemapData, selection)
        return [
          {
            ...baseSeriesConfig,
            data: filteredData
          }
        ]
      }

      const fallbackSeries = this.buildOnlyOneSeries({
        type: 'treemap',
        ...settings
      })
      const fallbackNames = []
      if (Array.isArray(fallbackSeries) && fallbackSeries.length) {
        const seriesData = Array.isArray(fallbackSeries[0].data) ? fallbackSeries[0].data : []
        seriesData.forEach(item => {
          const name = item && typeof item === 'object' ? item.name : item
          const normalized = this.normalizeLegendName(name)
          if (normalized) {
            fallbackNames.push(name)
          }
        })
        this.treemapLegendNames = fallbackNames
        const selection = this.syncTreemapLegendSelection(this.treemapLegendNames)
        const filteredData = this.filterTreemapDataBySelection(seriesData, selection)
        return [
          {
            ...baseSeriesConfig,
            data: filteredData
          }
        ]
      }
      this.treemapLegendNames = fallbackNames
      this.syncTreemapLegendSelection(this.treemapLegendNames)
      return [
        {
          ...baseSeriesConfig,
          data: []
        }
      ]
    },
    extractTreemapLegendNames(nodes) {
      const result = []
      const seen = new Set()
      const queue = Array.isArray(nodes) ? nodes.slice() : []
      for (let i = 0; i < queue.length; i += 1) {
        const node = queue[i]
        if (!node || typeof node !== 'object') continue
        const children = Array.isArray(node.children) ? node.children : []
        if (children.length) {
          for (let j = 0; j < children.length; j += 1) {
            queue.push(children[j])
          }
        } else {
          const name = Object.prototype.hasOwnProperty.call(node, 'name') ? node.name : null
          const normalized = this.normalizeLegendName(name)
          if (normalized && !seen.has(normalized)) {
            seen.add(normalized)
            result.push(name)
          }
        }
      }
      return result
    },
    getTreemapLabelConfig() {
      const showValues = Boolean(this.chartWithValue)
      return {
        label: {
          show: true,
          position: 'inside',
          align: 'center',
          verticalAlign: 'middle',
          color: this.styles.axis_text.color || '',
          distance: 0,
          formatter: params => {
            if (!params) return ''
            const name = params.name != null ? String(params.name) : ''
            if (!showValues) return name
            const data = params.data || {}
            const hasChildren = Array.isArray(data.children) && data.children.length > 0
            if (hasChildren) return name
            const rawValue = typeof params.value !== 'undefined' ? params.value : data.value
            const numericValue = Number(rawValue)
            const valueForDisplay = Number.isFinite(numericValue) ? numericValue : rawValue
            if (valueForDisplay === null || typeof valueForDisplay === 'undefined' || valueForDisplay === '') {
              return name
            }
            return `${name}\n\n${valueForDisplay}`
          }
        },
        labelLayout: params => {
          if (!showValues || !params || !params.rect || !params.labelLinePoints) return
          const rect = params.rect
          const labelRect = params.labelRect
          const offsetX = rect.x + rect.width / 2
          const offsetY = rect.y + rect.height / 2
          params.labelRect.x = offsetX - labelRect.width / 2
          params.labelRect.y = offsetY - labelRect.height / 2
        }
      }
    },
    syncTreemapLegendSelection(names = []) {
      const current = this.treemapLegendSelection || {}
      const next = {}
      for (let i = 0; i < names.length; i += 1) {
        const rawName = names[i]
        const normalized = this.normalizeLegendName(rawName)
        if (!normalized) continue
        if (Object.prototype.hasOwnProperty.call(current, normalized)) {
          next[normalized] = current[normalized]
        } else {
          next[normalized] = true
        }
      }
      this.treemapLegendSelection = next
      return next
    },
    filterTreemapDataBySelection(data = [], selection = null) {
      if (!Array.isArray(data)) return []
      if (!selection) return data
      const keys = Object.keys(selection)
      const hasDisabled = keys.some(key => selection[key] === false)
      if (!hasDisabled) return data

      const filtered = []
      for (let i = 0; i < data.length; i += 1) {
        const node = data[i]
        if (!node || typeof node !== 'object') continue
        const children = Array.isArray(node.children) ? node.children : null
        if (children && children.length) {
          const filteredChildren = []
          let total = 0
          for (let j = 0; j < children.length; j += 1) {
            const child = children[j]
            if (!child || typeof child !== 'object') continue
            const normalizedChildName = this.normalizeLegendName(child.name)
            if (normalizedChildName && selection[normalizedChildName] === false) {
              continue
            }
            const value = Number(child.value)
            if (Number.isFinite(value)) {
              total += value
            }
            filteredChildren.push({ ...child })
          }
          if (!filteredChildren.length) continue
          filtered.push({
            ...node,
            children: filteredChildren,
            value: total
          })
          continue
        }
        const normalizedNodeName = this.normalizeLegendName(node.name)
        if (normalizedNodeName && selection[normalizedNodeName] === false) {
          continue
        }
        filtered.push({ ...node })
      }
      return filtered
    },
    getTreemapLegendSelectedMap(names = []) {
      const selection = this.treemapLegendSelection || {}
      const selectedMap = {}
      for (let i = 0; i < names.length; i += 1) {
        const rawName = names[i]
        const normalized = this.normalizeLegendName(rawName)
        if (!normalized) continue
        const isSelected = Object.prototype.hasOwnProperty.call(selection, normalized)
          ? selection[normalized] !== false
          : true
        selectedMap[rawName] = isSelected
      }
      return selectedMap
    },
    buildTreemapData() {
      const groupIndex = this.axisGroup
      const hasGroupIndex = groupIndex || groupIndex === 0
      if (!hasGroupIndex) return null

      const resolvedKeyIndex = (this.axisKey || this.axisKey === 0) ? this.axisKey : 0
      const valueIndices = Array.isArray(this.axisValues) ? this.axisValues.slice() : []
      if (!valueIndices.length) return null

      const groupMap = new Map();

      (Array.isArray(this.rows) ? this.rows : []).forEach((row) => {
        if (!Array.isArray(row)) return

        const rawGroupLabel = row[groupIndex]
        const groupLabel = rawGroupLabel != null && rawGroupLabel !== '' ? String(rawGroupLabel) : 'Без группы'
        const groupKey = this.normalizeLegendName(groupLabel) || 'Без группы'

        const rawKeyLabel = row[resolvedKeyIndex]
        const keyLabel = rawKeyLabel != null && rawKeyLabel !== '' ? String(rawKeyLabel) : null
        if (!keyLabel) return
        const keyMapKey = this.normalizeLegendName(keyLabel)
        if (!keyMapKey) return

        let numericValue = 0
        let hasFiniteValue = false
        valueIndices.forEach((index) => {
          const rawValue = row[index]
          if (rawValue === null || typeof rawValue === 'undefined' || rawValue === '') return
          const resolvedValue = typeof rawValue === 'number' ? rawValue : Number(rawValue)
          if (Number.isFinite(resolvedValue)) {
            numericValue += resolvedValue
            hasFiniteValue = true
          }
        })

        if (!hasFiniteValue) return

        const groupEntry = groupMap.get(groupKey) || {
          label: groupLabel,
          total: 0,
          childrenMap: new Map()
        }

        groupEntry.total += numericValue
        const childEntry = groupEntry.childrenMap.get(keyMapKey) || { name: keyLabel, value: 0 }
        childEntry.value += numericValue
        groupEntry.childrenMap.set(keyMapKey, childEntry)
        groupMap.set(groupKey, groupEntry)
      })

      const result = []
      groupMap.forEach((entry) => {
        const children = Array.from(entry.childrenMap.values())
        if (!children.length) return
        result.push({
          name: entry.label,
          value: entry.total,
          children
        })
      })

      return result.length ? result : null
    },
    renderOption() {
      if (!this.chart) return

      const categories = this.axisDirection === 'column' ?
        this.activeKeys :
        this.activeColumns.map((el, i) => this.getHeadLabel(el.title, i))

      const legendTooltipMap = this.buildLegendTooltipMap()
      const legendData = this.computeLegendData()

      const legendConfig = {
        show: false,
        bottom: 0,
        left: 'center',
        orient: 'horizontal',
        type: 'scroll',
      }

      if (legendData.length) {
        legendConfig.data = legendData
      }

      let option = {
        title: { text: this.title.length ? this.title : 'График', textStyle: { color: this.styles.axis_text.color || '' } },
        tooltip: this.getDefaultTooltipConfig('axis', { axisPointer: { type: 'line' } }),
        legend: { ...legendConfig },
        barGap: 0,
        toolbox: {
          feature: {}
        },
        grid: { left: 40, right: 20, top: 60, bottom: this.axisZEnabled ? 0 : 40, outerBounds: { bottom: 0 } },
      };

      let colorList;
      if (this.seriesPalette) {
        const palette = [this.seriesPalette.main_color, ...this.seriesPalette.colors];
        if (palette.length < this.activeKeys.length) {
          for (let i = 0; i < this.activeKeys.length - palette.length; i++) {
            palette.push(adjustColorBrightness(palette[i], 1.10))
          }
        }
        option.color = palette;
        colorList = palette;
      } else if (this.styles?.series_color.color) {
        option.color = [this.styles?.series_color.color];
        let colors = [];
        let oldColor = this.styles.series_color.color;
        for (let i = 0; i < this.activeKeys.length; i++) {
          const brightnessColor = adjustColorBrightness(oldColor, 1.05)
          if (i > 0) {
            colors.push(brightnessColor);
            oldColor = brightnessColor;
          } else {
            colors.push(oldColor);
          }
        }
        colorList = colors;
      } else {
        const defaultPalette = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];
        const palette = defaultPalette;
        if (palette.length < this.activeKeys.length) {
          for (let i = 0; i < this.activeKeys.length - palette.length; i++) {
            palette.push(adjustColorBrightness(palette[i], 1.10))
          }
        }
        option.color = palette;
        colorList = palette;
      }

      const labelOption = {
        show: this.axisZEnabled || this.chartWithValue,
        formatter: '{a}',
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 8,
        // textBorderColor: this.styles.chart_bg.color,
        // textBorderWidth: 1,
      }

      switch (this.type) {
      case 'line_base':
        option.series = this.buildSeries({
          type: 'line',
        })
        option.xAxis = { type: 'category', data: categories, axisLabel: { show: true, color: this.styles.axis_text.color, interval: 'auto', hideOverlap: false, rotate: this.styles.axis_rotate.value }, }
        option.yAxis = { axisLabel: { color: this.styles.axis_text.color } }
        option.color = colorList;
        break;

      case 'line_smooth':
        option.series = this.buildSeries({
          type: 'line',
          smooth: true,
        })
        option.xAxis = { type: 'category', data: categories, axisLabel: { show: true, color: this.styles.axis_text.color, interval: 'auto', hideOverlap: false, rotate: this.styles.axis_rotate.value }, }
        option.yAxis = { axisLabel: { color: this.styles.axis_text.color } }
        option.color = colorList;
        break;

      case 'histogram_base':
        option.series = this.buildSeries({
          type: 'bar',
          label: { ...labelOption, formatter: `{a}${this.chartWithValue ? ': {c}' : ''}` },
        })
        option.tooltip = this.getDefaultTooltipConfig('axis', { axisPointer: { type: 'shadow' } })
        option.xAxis = { type: 'category', data: categories, axisLabel: { show: !this.axisZEnabled || this.chartWithValue, color: this.styles.axis_text.color, interval: 'auto', hideOverlap: false, rotate: this.styles.axis_rotate.value }, }
        option.yAxis = { axisLabel: { color: this.styles.axis_text.color } }
        option.color = colorList;
        break;

      case 'histogram_radius':
        option.series = this.buildSeries({
          type: 'bar',
          label: { ...labelOption, formatter: `{a}${this.chartWithValue ? ': {c}' : ''}` },
          itemStyle: { borderRadius: [20, 20, 0, 0] }
        })
        option.tooltip = this.getDefaultTooltipConfig('axis', { axisPointer: { type: 'shadow' } })
        option.xAxis = { type: 'category', data: categories, axisLabel: { show: !this.axisZEnabled || this.chartWithValue, color: this.styles.axis_text.color, interval: 'auto', hideOverlap: false, rotate: this.styles.axis_rotate.value }, }
        option.yAxis = { axisLabel: { color: this.styles.axis_text.color } }
        option.color = colorList;
        option.barGap = null;
        break;

      case 'histogram_horiz':
        option.series = this.buildSeries({
          type: 'bar',
          label: { ...labelOption, show: true, rotate: 0, align: 'left', position: 'insideLeft', verticalAlign: null, distance: 10, ...(this.chartWithValue ? { formatter: '{a}:  {c}' } : {}) },
        })
        option.xAxis = { axisLabel: { color: this.styles.axis_text.color } }
        option.yAxis = { type: 'category', data: categories.reverse(), axisLabel: { color: this.styles.axis_text.color } }
        option.series.forEach(el => el.data.reverse())
        option.color = colorList;
        break;

      case 'histogram_horiz_radius':
        option.series = this.buildSeries({
          type: 'bar',
          label: { ...labelOption, rotate: 0, align: 'left', position: 'insideLeft', verticalAlign: null, distance: 10, ...(this.chartWithValue ? { formatter: '{a}:  {c}' } : {}) },
          itemStyle: { borderRadius: [0, 20, 20, 0] }
        })
        option.xAxis = { axisLabel: { color: this.styles.axis_text.color } }
        option.yAxis = { type: 'category', data: categories.reverse(), axisLabel: { color: this.styles.axis_text.color } }
        option.barGap = null;
        option.series.forEach(el => el.data.reverse())
        option.color = colorList;
        break;

      case 'circle_base':
        option.series = this.buildOnlyOneSeries({
          type: 'pie',
          top: 40,
          bottom: 60,
          radius: [`${this.styles.circle_inner_empty.value || 0}%`, '70%'],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          },
          label: {
            show: this.chartWithValue,
            color: this.styles.axis_text.color,
            formatter: this.chartWithValue ? ' {span|{b}} \n {c|{c}} {per|{d}%} ' : '  {b}  ',
            backgroundColor: '#F6F8FC',
            borderColor: '#8C8D8E',
            align: 'center',
            padding: [2, 1],
            fontSize: 12,
            lineHeight: 16,
            borderWidth: 1,
            borderRadius: 4,
            rich: {
              span: {
                color: '#4C5058',
                align: 'center'
              },
              c: {
                fontSize: 11,
                align: 'center'
              },
              per: {
                fontSize: 11,
                color: '#fff',
                backgroundColor: '#4C5058',
                padding: [2, 2],
                borderRadius: 4,
                align: 'center'
              }
            }
          },
        })
        option.tooltip = this.getDefaultTooltipConfig('item')
        option.legend = {
          ...legendConfig,
          orient: 'vertical',
          left: 'left'
        }
        option.legend.bottom = null
        break;

      case 'circle_radius':
        option.series = this.buildOnlyOneSeries({
          type: 'pie',
          top: 40,
          bottom: 60,
          radius: [`${this.styles.circle_inner_empty.value}%`, '70%'],
          // avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2,
          },
          label: {
            show: this.chartWithValue,
            // position: 'center',
            color: this.styles.axis_text.color,
            // textBorderColor: this.styles.chart_bg.color,
            // textBorderWidth: 1,
            align: 'center',
            formatter: this.chartWithValue ? ' {span|{b}} \n {c|{c}} {per|{d}%} ' : '  {b}  ',
            backgroundColor: '#F6F8FC',
            borderColor: '#8C8D8E',
            padding: [2, 1],
            fontSize: 12,
            lineHeight: 16,
            borderWidth: 1,
            borderRadius: 4,
            rich: {
              span: {
                color: '#4C5058',
                align: 'center'
              },
              c: {
                fontSize: 11,
                align: 'center'
              },
              per: {
                fontSize: 11,
                color: '#fff',
                backgroundColor: '#4C5058',
                padding: [2, 2],
                borderRadius: 4,
                align: 'center'
              }
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 16,
              fontWeight: 'bold'
            }
          },
        })
        option.tooltip = this.getDefaultTooltipConfig('item')
        option.legend = {
          ...legendConfig,
          bottom: '5%',
          left: 'center'
        }
        break;

      case 'funnel_base':
        option.series = this.buildOnlyOneSeries({
          type: 'funnel',
          left: '10%',
          top: 60,
          bottom: 0,
          // min: 0,
          // max: 100,
          width: '80%',
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 2,
          label: {
            show: true,
            position: 'inside',
            formatter: `{b}${this.chartWithValue ? ': {c}' : ''}`
          },
          labelLine: {
            length: 10,
            lineStyle: {
              width: 1,
              type: 'solid'
            }
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          emphasis: {
            label: {
              fontSize: 20
            }
          },
        })
        option.tooltip = this.getDefaultTooltipConfig('item', { formatter: '{b} : {c}' })
        break;
      case 'treemap_base':
        option.series = this.buildTreemapSeries()
        option.tooltip = this.getDefaultTooltipConfig('item', {
          formatter: params => {
            if (!params) return ''
            const treePathInfo = Array.isArray(params.treePathInfo) ? params.treePathInfo : []
            const namesPath = treePathInfo
              .map(item => (item && item.name != null) ? String(item.name) : '')
              .filter(name => name !== '')
            let groupName = ''
            if (namesPath.length >= 2) {
              groupName = namesPath[namesPath.length - 2] || ''
            } else if (namesPath.length === 1) {
              groupName = namesPath[0] || ''
            }
            const nodeName = params.name && params.name !== groupName ? params.name : ''
            const value = Number.isFinite(params.value)
              ? params.value
              : (params.data && Number.isFinite(params.data.value) ? params.data.value : null)
            const lines = []
            if (groupName) {
              lines.push(`<strong>${groupName}</strong>`)
            }
            if (nodeName || value !== null) {
              let detail = ''
              if (nodeName) {
                detail += nodeName
              }
              if (value !== null) {
                detail += detail ? ': ' : ''
                detail += String(value)
              }
              if (detail) {
                lines.push(detail)
              }
            }
            return lines.join('<br/>')
          }
        })
        {
          const legendNames = Array.isArray(this.treemapLegendNames)
            ? this.treemapLegendNames.filter(name => this.normalizeLegendName(name) !== '')
            : []
          option.legend = {
            ...legendConfig,
            show: legendNames.length > 0,
            orient: 'vertical',
            left: 'left',
            bottom: null,
            data: legendNames,
            selected: this.getTreemapLegendSelectedMap(legendNames)
          }
        }
        break;
      default:
        option.series = this.buildSeries({
          type: 'line',
        })
        option.xAxis = { type: 'category', data: categories, axisLabel: { show: true, color: this.styles.axis_text.color, interval: 'auto', hideOverlap: false, rotate: 90, }, }
        option.yAxis = { axisLabel: { color: this.styles.axis_text.color } }
        break;
      }

      this.chart.setOption(option, true);
      this.legendTooltipMap = legendTooltipMap;
      this.updateLegendItems();
    },
    getColumnTitle(index) {
      let n = Number(index)
      if (!Number.isFinite(n) || n < 0) return ''
      let result = ''
      n = n + 1
      while (n > 0) {
        const rem = (n - 1) % alphabet.length
        result = String(alphabet[rem] || '') + result
        n = Math.floor((n - 1) / alphabet.length)
      }
      return result
    },
    getHeadLabel(label, index) {
      if (label && String(label).trim() !== '') return label
      return this.getColumnTitle(index)
    },
    buildLegendTooltipMap() {
      const map = Object.create(null)
      const meta = this.meta || {}
      const axisKey = this.axisKey
      if ((!axisKey && axisKey !== 0) || !Array.isArray(this.rows) || this.rows.length === 0) return map
      const columnMeta = meta[axisKey] || meta[String(axisKey)]
      if (!columnMeta) return map

      this.rows.forEach((row, index) => {
        const key = this.normalizeLegendName(this.activeKeys[index])
        if (!key) return
        const cellMeta = columnMeta[index] || columnMeta[String(index)]
        const objectId = cellMeta && cellMeta.payload && cellMeta.payload.objectId
        if (!objectId) return
        map[key] = objectId
      })

      return map
    },
    computeLegendData() {
      let option = null
      try {
        option = this.chart && typeof this.chart.getOption === 'function' ? this.chart.getOption() : null
      } catch (err) {
        option = null
      }

      const legendOption = option ? (Array.isArray(option.legend) ? option.legend[0] : option.legend) : null
      const legendData = legendOption && Array.isArray(legendOption.data) ? legendOption.data.slice() : []
      if (legendData.length) {
        return legendData
      }

      const seriesList = option && Array.isArray(option.series) ? option.series : []

      const isSingleSeriesByKeys = this.type && (this.type.startsWith('circle') || this.type.startsWith('funnel'))

      if (isSingleSeriesByKeys) {
        const keys = Array.isArray(this.activeKeys) ? this.activeKeys.slice() : []
        const filteredKeys = keys.filter(name => this.normalizeLegendName(name) !== '')
        if (filteredKeys.length) {
          return filteredKeys
        }

        if (seriesList.length) {
          const series = seriesList[0] || {}
          const data = Array.isArray(series.data) ? series.data : []
          const names = data
            .map(item => {
              if (item && typeof item === 'object' && !Array.isArray(item) && Object.prototype.hasOwnProperty.call(item, 'name')) {
                return item.name
              }
              return item
            })
            .filter(name => this.normalizeLegendName(name) !== '')

          if (names.length) {
            return names
          }
        }
      }

      if (seriesList.length) {
        return seriesList
          .map((series, index) => {
            if (series && typeof series.name === 'string' && this.normalizeLegendName(series.name) !== '') {
              return series.name
            }
            const columnTitle = this.columns && this.columns[index] ? this.columns[index].title : null
            const fallback = columnTitle != null ? this.getHeadLabel(columnTitle, index) : `Series ${index + 1}`
            return fallback
          })
          .filter(name => this.normalizeLegendName(name) !== '')
      }

      return []
    },
    updateLegendItems(map = null) {
      if (!this.chart) return
      let option
      try {
        option = this.chart.getOption()
      } catch (err) {
        return
      }

      const legendOption = Array.isArray(option.legend) ? option.legend[0] : option.legend || {}
      let rawLegendData = Array.isArray(legendOption.data) ? legendOption.data.slice() : []
      const selected = legendOption && legendOption.selected ? legendOption.selected : {}
      const seriesList = Array.isArray(option.series) ? option.series : []
      const palette = Array.isArray(option.color) && option.color.length ? option.color : this.getDefaultPalette()
      const tooltipMap = map || this.legendTooltipMap || {}

      if (!rawLegendData.length) {
        rawLegendData = this.computeLegendData()
      }

      const normalizedLegendData = rawLegendData
        .map(name => ({ original: name, normalized: this.normalizeLegendName(name) }))
        .filter(item => item.normalized !== '')

      if (!normalizedLegendData.length) {
        this.legendItems = []
        return
      }

      const series = this.type && this.type.startsWith('circle')
        ? (Array.isArray(seriesList) && seriesList.length ? seriesList[0] : null)
        : null

      const seriesData = series && Array.isArray(series.data) ? series.data : []
      const dataByNormalizedName = new Map()
      seriesData.forEach((item, index) => {
        const dataName = this.normalizeLegendName(
          item && typeof item === 'object' && !Array.isArray(item) ? item.name : item
        )
        if (!dataName) return
        const entry = dataByNormalizedName.get(dataName) || { indices: [], rawNames: [] }
        entry.indices.push(index)
        entry.rawNames.push(
          item && typeof item === 'object' && !Array.isArray(item) && Object.prototype.hasOwnProperty.call(item, 'name')
            ? item.name
            : dataName
        )
        dataByNormalizedName.set(dataName, entry)
      })

      const items = normalizedLegendData.map((item, index) => {
        const color = this.resolveSeriesColor(
          seriesList,
          this.findSeriesIndexByName(seriesList, item.normalized),
          palette,
          index,
          item.normalized,
          item.original,
          dataByNormalizedName
        )
        const objectId = Object.prototype.hasOwnProperty.call(tooltipMap, item.normalized) ? tooltipMap[item.normalized] : null
        const isSelected = this.resolveLegendSelectionState(
          item,
          selected,
          series ? series.selected : null,
          dataByNormalizedName
        )

        return {
          name: item.original,
          label: item.normalized,
          markerColor: color,
          color: this.styles?.axis_text?.color || '',
          selected: isSelected,
          objectId
        }
      })

      this.legendItems = items
    },
    resolveSeriesColor(seriesList, seriesIndex, palette, fallbackIndex, legendName, rawName = null, dataByNormalizedName = null) {
      const defaultPalette = palette && palette.length ? palette : this.getDefaultPalette()
      if (seriesIndex === -1) {
        const colorFromData = this.findColorInSeriesData(seriesList, legendName, defaultPalette, rawName, dataByNormalizedName)
        return colorFromData || defaultPalette[fallbackIndex % defaultPalette.length] || defaultPalette[0]
      }
      const series = seriesList[seriesIndex] || {}
      const colorFromData = this.findColorInSeriesData([series], legendName, defaultPalette, rawName, dataByNormalizedName)
      if (colorFromData) return colorFromData
      return (
        (series.itemStyle && series.itemStyle.color) ||
        (series.lineStyle && series.lineStyle.color) ||
        defaultPalette[seriesIndex % defaultPalette.length] ||
        defaultPalette[0]
      )
    },
    findColorInSeriesData(seriesList, legendName, palette, rawName = null, dataByNormalizedName = null) {
      const normalizedTarget = this.normalizeLegendName(legendName)
      const rawTarget = typeof rawName === 'string' ? rawName : legendName
      if (!normalizedTarget) return null
      const normalizedPreferred = (dataByNormalizedName && dataByNormalizedName.get(normalizedTarget)) || null
      const preferredIndices = normalizedPreferred ? normalizedPreferred.indices || [] : []

      for (const series of Array.isArray(seriesList) ? seriesList : []) {
        if (!series || !Array.isArray(series.data)) continue
        for (let i = 0; i < series.data.length; i += 1) {
          const item = series.data[i]
          let itemName = null
          let itemColor = null

          if (item && typeof item === 'object' && !Array.isArray(item)) {
            itemName = this.normalizeLegendName(
              Object.prototype.hasOwnProperty.call(item, 'name') ? item.name : ''
            )
            itemColor = (item.itemStyle && item.itemStyle.color) || item.color || null
          } else {
            itemName = this.normalizeLegendName(item)
          }

          if (!itemName) continue

          const matchesByName = itemName === normalizedTarget || itemName === rawTarget
          const matchesByIndex = preferredIndices.includes(i)
          if (matchesByName || matchesByIndex) {
            if (itemColor) return itemColor
            if (Array.isArray(series.color) && series.color.length) {
              const maybe = series.color[i % series.color.length]
              if (maybe) return maybe
            }
            if (palette && palette.length) {
              return palette[i % palette.length]
            }
            return null
          }
        }
      }

      return null
    },
    resolveLegendSelectionState(item, legendSelected, seriesSelected, dataByNormalizedName = null) {
      const rawName = item.original
      const normalizedName = item.normalized

      if (seriesSelected && Object.prototype.hasOwnProperty.call(seriesSelected, rawName)) {
        return seriesSelected[rawName] !== false
      }
      if (seriesSelected && Object.prototype.hasOwnProperty.call(seriesSelected, normalizedName)) {
        return seriesSelected[normalizedName] !== false
      }

      if (legendSelected && Object.prototype.hasOwnProperty.call(legendSelected, rawName)) {
        return legendSelected[rawName] !== false
      }
      if (legendSelected && Object.prototype.hasOwnProperty.call(legendSelected, normalizedName)) {
        return legendSelected[normalizedName] !== false
      }

      if (dataByNormalizedName && dataByNormalizedName.has(normalizedName)) {
        const entry = dataByNormalizedName.get(normalizedName)
        if (entry && Array.isArray(entry.rawNames)) {
          for (const candidate of entry.rawNames) {
            if (legendSelected && Object.prototype.hasOwnProperty.call(legendSelected, candidate)) {
              return legendSelected[candidate] !== false
            }
            if (seriesSelected && Object.prototype.hasOwnProperty.call(seriesSelected, candidate)) {
              return seriesSelected[candidate] !== false
            }
          }
        }
      }

      return true
    },
    findSeriesIndexByName(seriesList, normalizedName) {
      if (!Array.isArray(seriesList)) return -1
      return seriesList.findIndex(series => this.normalizeLegendName(series && series.name) === normalizedName)
    },
    getDefaultPalette() {
      return ['#5470C6', '#91CC75', '#EE6666', '#73C0DE', '#FAC858', '#3BA272', '#FC8452', '#9A60B4', '#EA7CCC']
    },
    getDefaultTooltipConfig(trigger = 'axis', extra = {}) {
      const base = { trigger }
      if (trigger === 'axis' && !extra.axisPointer) {
        base.axisPointer = { type: 'shadow' }
      }
      return { ...base, ...extra }
    },
    handleLegendSelectChanged() {
      this.updateLegendItems()
    },
    toggleLegendItem(name) {
      if (!this.chart || !name) return
      const normalizedName = this.normalizeLegendName(name)
      if (this.type === 'treemap_base') {
        if (!normalizedName) return
        const current = this.treemapLegendSelection || {}
        const next = { ...current }
        const isCurrentlySelected = !Object.prototype.hasOwnProperty.call(next, normalizedName) || next[normalizedName] !== false
        next[normalizedName] = isCurrentlySelected ? false : true
        this.treemapLegendSelection = next
        this.renderOption()
        return
      }
      const actionName = this.findMatchingLegendName(name) || name || normalizedName
      try {
        this.chart.dispatchAction({
          type: 'legendToggleSelect',
          name: actionName
        })
      } catch (err) {}
      this.updateLegendItems()
    },
    handleLegendMouseEnter(name) {
      if (!this.chart || !name) return
      try {
        const normalizedName = this.normalizeLegendName(name)
        const actionName = this.findMatchingLegendName(name) || name || normalizedName
        this.chart.dispatchAction({
          type: 'legendHighlight',
          name: actionName
        })
      } catch (err) {}
    },
    handleLegendMouseLeave(name) {
      if (!this.chart || !name) return
      try {
        const normalizedName = this.normalizeLegendName(name)
        const actionName = this.findMatchingLegendName(name) || name || normalizedName
        this.chart.dispatchAction({
          type: 'legendUnHighlight',
          name: actionName
        })
      } catch (err) {}
    },
    findMatchingLegendName(name) {
      if (!this.chart || !name) return null
      const normalizedTarget = this.normalizeLegendName(name)

      let option
      try {
        option = this.chart.getOption()
      } catch (err) {
        return null
      }

      const legendOption = Array.isArray(option.legend) ? option.legend[0] : option.legend || {}
      const legendData = Array.isArray(legendOption.data) ? legendOption.data : []

      let found = legendData.find(entry => {
        const normalized = this.normalizeLegendName(entry)
        return normalized === normalizedTarget || entry === name
      })

      if (found) return found

      const seriesList = Array.isArray(option.series) ? option.series : []
      for (const series of seriesList) {
        if (!series || !Array.isArray(series.data)) continue
        for (const item of series.data) {
          if (item && typeof item === 'object' && !Array.isArray(item)) {
            const itemName = this.normalizeLegendName(item.name)
            if (itemName === normalizedTarget || item.name === name) {
              return item.name
            }
          } else if (this.normalizeLegendName(item) === normalizedTarget || item === name) {
            return item
          }
        }
      }

      return null
    },
    normalizeLegendName(value) {
      if (value === null || typeof value === 'undefined') return ''
      return String(value).trim()
    },
    reduceCommaToDot(string) {
      typeof string !== 'string' && (string = String(string));
      return string.replace(',', '.');
    },
  }
}
